import { createStyles } from "@material-ui/core";

export type UsersClassKey = "pageTitle";

export const UsersStyleRules = createStyles({
  pageTitle: {
    marginTop: "40px",
  },
});
